module.exports = __webpack_public_path__ + "img/vertical_7_6_8017.6ee10d47.png";